module.exports = __webpack_public_path__ + "img/move02.333fdb29.png";